import type { FC } from 'react';

import * as Styled from './dot-separator.styles';

export const DotSeparator: FC = () => <Styled.Separator>•</Styled.Separator>;
